import React from 'react';
import ReactDom from 'react-dom';

import CheckoutBillingFields from '../Components/CheckoutBillingFields/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import Loader from '../Components/Loader/index.jsx';

import { AjaxService } from '../Services/Ajax/index.jsx';


export default function(document) {
  var elements = document.querySelectorAll('[data-react-component="cs-checkout-billing-fields"]');

  if (elements && elements.length) {
    var countries = AjaxService.fetch('theme:countries');

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var fields = JSON.parse(element.dataset.fields);
      var isUser = element.dataset.user;
      var csStep = element.dataset.cs_step;

      var WrappedComponent = Loader(CheckoutBillingFields, countries, 'countries');

      ReactDom.render(
        <ErrorBoundary>
          <WrappedComponent fields={fields} isUser={isUser} csStep={csStep} />
        </ErrorBoundary>,
        element
      );
    }
  }
};

